import React, { useState } from 'react';
import { Link, useLocation  } from 'react-router-dom';
import { ReactComponent as Logo } from '../assets/svg/logo.svg';
import {isMobile} from 'mobile-device-detect';
import '../styles/navbar.css';

const Navbar = () => {
	const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
	const [isHovered, setIsHovered] =useState(false);
	const location = useLocation();

	const toggleMobileMenu = () => {
		setMobileMenuOpen(!isMobileMenuOpen);
	};

	const isActive = (path) => location.pathname === path ? 'active' : '';

	const handleMouseEnter = () => setIsHovered(true);
	const handleMouseLeave = () => setIsHovered(false);


	if (isMobile) return (
		<nav className="mobile-navbar">
			<Link to="/" className="logo">ProMS</Link>
			<div className="hamburger" onClick={toggleMobileMenu}>
				☰
			</div>
			<ul className={`mobile-nav-links ${isMobileMenuOpen ? 'show' : ''}`}>
				<li><Link to="/" className={isActive('/')}>Home</Link></li>
				<li><Link to="/aims" className={isActive('/aims')}>Aims</Link></li>
				<li><Link to="/collaborators" className={isActive('/collaborators')}>Collaborators</Link></li>
				<li><Link to="/project" className={isActive('/project')}>Project</Link></li>
				<li><Link to="/about" className={isActive('/about')}>About</Link></li>
				<li><Link to="/events" className={isActive('/events')}>Events</Link></li>
				{/* <li><Link to="/contact" className={isActive('/contact')}>Contact</Link></li> */}
			</ul>
		</nav>
	)

	return (
		<nav className="navbar">
			<ul className='nav-links'>
				<span className="nav-links-enclosure logo-link-enclosure">
					<li>
						<Link 
							to="/" 
							className="logo"
							onMouseEnter={handleMouseEnter}
							onMouseLeave={handleMouseLeave}
						>
							<Logo className={`logo-svg ${isHovered ? 'hovered' : ''}`}/>
						</Link>
					</li>
				</span>
				<span className="nav-links-enclosure">
					<li><Link to="/" className={isActive('/')}>Home</Link></li>
					<li><Link to="/aims" className={isActive('/aims')}>Aims</Link></li>
					<li><Link to="/collaborators" className={isActive('/collaborators')}>Collaborators</Link></li>
					<li><Link to="/project" className={isActive('/project')}>Project</Link></li>
					<li><Link to="/about" className={isActive('/about')}>About</Link></li>
					<li><Link to="/events" className={isActive('/events')}>Events</Link></li>
					{/* <li><Link to="/contact" className={isActive('/contact')}>Contact</Link></li> */}
				</span>
			</ul>
		</nav>
	);
};

export default Navbar;
